"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorSQLMap = exports.OrderBy = void 0;
var OrderBy;
(function (OrderBy) {
    OrderBy["Asc"] = "asc";
    OrderBy["Desc"] = "desc";
})(OrderBy || (exports.OrderBy = OrderBy = {}));
exports.operatorSQLMap = {
    eq: "=",
    gt: ">",
    gte: ">=",
    lt: "<",
    lte: "<=",
    like: "LIKE",
    in: "IN",
    neq: "<>",
};
